import type { Messages } from '~/locales/hu'
import { CONTACT_EMAIL, SITE_ORIGIN } from '~/composables/useI18n'

export function buildLocalBusinessSchema(m: Messages, inLanguage = 'hu', url = `${SITE_ORIGIN}/`) {
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Archestor Kft.',
    url,
    inLanguage,
    description: m.schema.description,
    email: CONTACT_EMAIL,
    priceRange: '$$',
    address: {
      '@type': 'PostalAddress',
      addressLocality: m.schema.addressLocality,
      addressCountry: 'HU'
    },
    areaServed: m.schema.areaServed.map((item) => ({
      '@type': item.type,
      name: item.name
    })),
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: m.schema.catalogName,
      itemListElement: m.schema.services.map((service) => ({
        '@type': 'OfferCatalog',
        name: service.name,
        description: service.description
      }))
    }
  }
}